import React from 'react'

class VideoLoader extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      isLoading: true
    }
  }
  componentDidMount () {
    this.$video.addEventListener('canplay', () => {
      this.setState({isLoading: false})
    })
  }

  render () {
    return (
      <div className='video-loader'>
        {this.state.isLoading && <div className='video-loader__spinner' />}
        <video {...this.props} ref={$video => { this.$video = $video }}>
          {this.props.children}
        </video>
      </div>
    )
  }
}

export default VideoLoader



// WEBPACK FOOTER //
// ./client/components/videoLoader.js